<div class="meter">
    <div class="meter__header">
        <p>{{ (isTorque ? 'PAGE.ANALYSIS.RI_RECOMMENDED_TORQUE.LBL' : 'PAGE.ANALYSIS.RI_RECOMMENDED_FORCE.LBL') | translate }}</p>
        <p>{{ (isTorque ? 'PAGE.ANALYSIS.TORQUE_LIMIT.LBL' : 'PAGE.ANALYSIS.FORCE_LIMIT.LBL') | translate }}</p>
    </div>
    <div class="meter__bar-container">
        <div
            *ngIf="greenLimit && redLimit && greenLimit > MIN_LIMIT_VALUE"
            class="meter__bar meter__bar--green"
            [style.width]="greenLimit / redLimit < MAX_BAR_WIDTH / 100 ? (greenLimit / redLimit) * 100 + '%' : MAX_BAR_WIDTH + '%'"></div>
        <div
            *ngIf="yellowLimit && redLimit && yellowLimit > MIN_LIMIT_VALUE && yellowLimit < redLimit"
            class="meter__bar meter__bar--yellow"
            [style.width]="yellowLimit / redLimit < MAX_BAR_WIDTH / 100 ? (yellowLimit / redLimit) * 100 + '%' : MAX_BAR_WIDTH + '%'"></div>
        <div [ngClass]="redLimit ? 'meter__bar meter__bar--red' : 'meter__bar meter__bar--grey'"></div>
    </div>
    <div
        *ngIf="redLimit"
        class="meter__limits">
        <ds-badge
            *ngIf="greenLimit && yellowLimit && redLimit && greenLimit.toFixed(1) !== yellowLimit.toFixed(1) && greenLimit > MIN_LIMIT_VALUE"
            class="meter__limit meter__limit--green"
            [ngClass]="{
                'meter__limit meter__limit--custom-pos':
                    greenLimit / redLimit < GREEN_BADGE_MAX_POSITION / 100 &&
                    yellowLimit / redLimit - greenLimit / redLimit > MIN_DIFFERENCE / 200 &&
                    yellowLimit / redLimit < YELLOW_BADGE_MAX_POSITION / 100 &&
                    yellowLimit / redLimit - greenLimit / redLimit > MIN_DIFFERENCE / 200
            }"
            [style.left]="(greenLimit / redLimit) * 100 + '%'"
            tone="positive"
            label="{{
                (greenLimit - OFFSET_VALUE | number : '1.0-1') +
                    ((isTorque ? 'PAGE.ANALYSIS.CRITERION05.Nm.LBL' : 'PAGE.ANALYSIS.CRITERION05.N.LBL') | translate)
            }}">
        </ds-badge>

        <ds-badge
            *ngIf="
                greenLimit &&
                yellowLimit &&
                redLimit &&
                greenLimit.toFixed(1) !== yellowLimit.toFixed(1) &&
                yellowLimit > MIN_LIMIT_VALUE &&
                yellowLimit < redLimit
            "
            class="meter__limit meter__limit--yellow"
            [ngClass]="{
                'meter__limit meter__limit--custom-pos':
                    yellowLimit / redLimit < YELLOW_BADGE_MAX_POSITION / 100 &&
                    yellowLimit / redLimit - greenLimit / redLimit > MIN_DIFFERENCE / 200 &&
                    greenLimit / redLimit < GREEN_BADGE_MAX_POSITION / 100 &&
                    yellowLimit / redLimit - greenLimit / redLimit > MIN_DIFFERENCE / 200
            }"
            [style.left]="(yellowLimit / redLimit) * 100 + '%'"
            tone="caution"
            label="{{
                (yellowLimit - OFFSET_VALUE | number : '1.0-1') +
                    ((isTorque ? 'PAGE.ANALYSIS.CRITERION05.Nm.LBL' : 'PAGE.ANALYSIS.CRITERION05.N.LBL') | translate)
            }}">
        </ds-badge>

        <ds-badge
            *ngIf="greenLimit && yellowLimit && redLimit && greenLimit.toFixed(1) !== yellowLimit.toFixed(1) && redLimit > MIN_LIMIT_VALUE"
            class="meter__limit meter__limit--red"
            [style.left]="RED_BADGE_POSITION + '%'"
            tone="critical"
            label="{{
                greenLimit.toFixed(1) !== redLimit.toFixed(1) && yellowLimit.toFixed(1) !== redLimit.toFixed(1)
                    ? (redLimit - OFFSET_VALUE | number : '1.0-1') +
                      ((isTorque ? 'PAGE.ANALYSIS.CRITERION05.Nm.LBL' : 'PAGE.ANALYSIS.CRITERION05.N.LBL') | translate)
                    : (redLimit + OFFSET_VALUE | number : '1.0-1') +
                      ((isTorque ? 'PAGE.ANALYSIS.CRITERION05.Nm.LBL' : 'PAGE.ANALYSIS.CRITERION05.N.LBL') | translate)
            }}">
        </ds-badge>

        <!-- Edge case handling for scenarios where greenLimit and yellowLimit are the same or yellowLimit is not defined -->
        <ng-container *ngIf="greenLimit && (!yellowLimit || yellowLimit.toFixed(1) === greenLimit.toFixed(1)) && redLimit">
            <ds-badge
                *ngIf="greenLimit > MIN_LIMIT_VALUE"
                class="meter__limit meter__limit--green"
                [ngClass]="{
                    'meter__limit meter__limit--custom-pos': greenLimit / redLimit < YELLOW_BADGE_MAX_POSITION / 100
                }"
                [style.left]="(greenLimit / redLimit) * 100 + '%'"
                tone="positive"
                label="{{
                    (greenLimit - OFFSET_VALUE | number : '1.0-1') +
                        ((isTorque ? 'PAGE.ANALYSIS.CRITERION05.Nm.LBL' : 'PAGE.ANALYSIS.CRITERION05.N.LBL') | translate)
                }}">
            </ds-badge>

            <ds-badge
                *ngIf="redLimit > MIN_LIMIT_VALUE"
                class="meter__limit meter__limit--red"
                [style.left]="RED_BADGE_POSITION + '%'"
                tone="critical"
                label="{{
                    greenLimit.toFixed(1) !== redLimit.toFixed(1)
                        ? (redLimit - OFFSET_VALUE | number : '1.0-1') +
                          ((isTorque ? 'PAGE.ANALYSIS.CRITERION05.Nm.LBL' : 'PAGE.ANALYSIS.CRITERION05.N.LBL') | translate)
                        : (redLimit + OFFSET_VALUE | number : '1.0-1') +
                          ((isTorque ? 'PAGE.ANALYSIS.CRITERION05.Nm.LBL' : 'PAGE.ANALYSIS.CRITERION05.N.LBL') | translate)
                }}">
            </ds-badge>
        </ng-container>
    </div>
    <ds-hint
        *ngIf="!redLimit"
        [tone]="'neutral'"
        >{{ hintLabel | translate }}</ds-hint
    >
</div>
